import styled from '@emotion/styled'

import { palette, spacing, Text } from 'main/ui'

export const Container = styled(Text.withComponent('div'))`
  color: ${palette.slate};
  font-size: 14px;
  line-height: 21px;
  margin: auto;
  margin-top: ${spacing.majorScale(6)}px;
  text-align: center;

  > :not(:last-child) {
    margin-bottom: ${spacing.majorScale(1)}px;
    margin-right: ${spacing.majorScale(1)}px;
  }
`

export const Row = styled.div`
  > :not(:last-child) {
    margin-right: ${spacing.majorScale(1)}px;
  }
`
